import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useBasicCancelProceedPopupsStyles = makeStyles({
    header: {
        fontWeight: tokens.fontWeightBold,
        fontSize: tokens.fontSizeBase600
    },
    addButtonsContainer: {
        marginLeft: 'auto'
    },
    buttons: {
        width: '150px',
        height: '40px',
        fontSize: tokens.fontSizeBase400,
        ...shorthands.padding('0', tokens.spacingHorizontalXXXL)
    },
    cancelButton: {
        backgroundColor: 'white',
        color: 'black',
        ...shorthands.borderRadius(tokens.borderRadiusLarge),
        ':hover': {
            backgroundColor: tokens.colorNeutralBackground4,
            color: 'black'
        },
        marginRight: tokens.spacingHorizontalL
    },
    proceedButton: {
        backgroundColor: 'red',
        color: 'white',
        ...shorthands.borderWidth('0'),
        ...shorthands.borderRadius(tokens.borderRadiusLarge),
        ':hover': {
            backgroundColor: 'red',
            color: tokens.colorNeutralForegroundInverted,
            textShadow: 'var(--colorNeutralStroke1Hover) 0px 1px'
        }
    }
});
